module.exports = __webpack_public_path__ + "media/images/patent/x_10-4ad88132e5634cf0f20fd757b85459e5.png";